module.exports = __webpack_public_path__ + "img/cary-processing.56646ef3.png";